module.exports = __webpack_public_path__ + "img/03_Button-5.f808ade9.png";